export default "__VITE_ASSET__ojR9DUpB__"